export const watchInOrderToggleDataSet = { cy: 'watch-in-order-toggle' };
export const organizePlaylistContinueButtonDataSet = { cy: 'continue-from-organize-playlist-button' };
